/* src/app/components/controls/dialogs/sem-view-settings-dialog/sem-view-settings-dialog.component.css */
.wg-wizard-dialog {
  display: flex;
  width: 900px;
  height: 620px;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
}
.wg-wizard-sidebar {
  width: 260px;
  flex-shrink: 0;
  background: #f8fafc;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
}
.wg-wizard-sidebar-header {
  padding: 24px 24px 16px;
}
.wg-wizard-sidebar-header h2 {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  line-height: 1.4;
}
.wg-wizard-sidebar-header p {
  font-size: 11px;
  color: #94a3b8;
  margin: 4px 0 0;
}
.wg-wizard-sidebar-steps {
  flex: 1;
  padding: 8px 16px;
  overflow-y: auto;
}
.wg-wizard-step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  text-align: left;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  font-family: inherit;
}
.wg-wizard-step:hover {
  background: rgba(255, 255, 255, 0.6);
}
.wg-wizard-step-active {
  background: white !important;
  border-color: #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}
.wg-wizard-step-completed {
  opacity: 0.85;
}
.wg-wizard-step-completed:hover {
  opacity: 1;
}
.wg-wizard-step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 700;
  background: #f1f5f9;
  color: #94a3b8;
  transition: all 0.2s ease;
}
.wg-wizard-step-active .wg-wizard-step-number {
  background: #dbeafe;
  color: #2563eb;
  box-shadow: 0 0 0 3px #bfdbfe;
}
.wg-wizard-step-completed .wg-wizard-step-number {
  background: #dcfce7;
  color: #16a34a;
}
.wg-wizard-check {
  font-size: 14px;
  line-height: 1;
}
.wg-wizard-step-text {
  min-width: 0;
  padding-top: 2px;
}
.wg-wizard-step-title {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wg-wizard-step-active .wg-wizard-step-title {
  color: #0f172a;
}
.wg-wizard-step-completed .wg-wizard-step-title {
  color: #16a34a;
}
.wg-wizard-step-subtitle {
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.wg-wizard-step-optional {
  font-size: 9px;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-top: 2px;
}
.wg-wizard-sidebar-progress {
  padding: 16px 24px;
  border-top: 1px solid #e2e8f0;
}
.wg-wizard-progress-text {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  color: #94a3b8;
  margin-bottom: 6px;
}
.wg-wizard-progress-bar {
  height: 6px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}
.wg-wizard-progress-fill {
  height: 100%;
  background: #2563eb;
  border-radius: 999px;
  transition: width 0.4s ease-out;
}
.wg-wizard-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.wg-wizard-content-header {
  padding: 20px 32px 16px;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.wg-wizard-content-header h3 {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}
.wg-wizard-content-header p {
  font-size: 12px;
  color: #94a3b8;
  margin: 2px 0 0;
}
.wg-wizard-close-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  transition: all 0.15s ease;
}
.wg-wizard-close-btn:hover {
  background: #f1f5f9;
  color: #475569;
}
.wg-wizard-close-btn .material-symbols-outlined {
  font-size: 18px;
}
.wg-wizard-content-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.wg-wizard-content-body > .drag-drop-content {
  flex: 1;
  min-height: 0;
}
.wg-wizard-content-body > .wg-wizard-form,
.wg-wizard-content-body > .sort-view-settings,
.wg-wizard-content-body > .leftmenu-view-settings {
  flex: 0 0 auto;
}
.wg-wizard-content-body > .query-builder-view-settings {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.wg-wizard-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.wg-wizard-form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.wg-wizard-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
}
.wg-wizard-input {
  display: block;
  width: 100%;
}
:host ::ng-deep .wg-wizard-input input.sem-text-box,
:host ::ng-deep .wg-wizard-input input[type=text],
:host ::ng-deep .wg-wizard-input input[type=number],
:host ::ng-deep .wg-wizard-input input[type=password] {
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0 14px;
  font-size: 14px;
  font-family: inherit;
  color: #0f172a;
  background: white;
  outline: none;
  box-sizing: border-box;
}
:host ::ng-deep .wg-wizard-input input.sem-text-box:focus,
:host ::ng-deep .wg-wizard-input input[type=text]:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
.wg-wizard-select {
  width: 100%;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-text-field-wrapper {
  height: 42px !important;
  padding: 0 14px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: white !important;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-form-field-infix {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  min-height: unset !important;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .wg-wizard-select .mdc-line-ripple {
  display: none !important;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-form-field-focus-overlay {
  display: none !important;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-select-value-text {
  font-size: 14px !important;
  color: #0f172a;
}
:host ::ng-deep .wg-wizard-select .mat-mdc-select-arrow-wrapper {
  transform: none !important;
}
:host ::ng-deep .wg-wizard-select.disabled-select .mat-mdc-text-field-wrapper {
  background: #f8fafc !important;
  border-color: #f1f5f9 !important;
}
:host ::ng-deep .wg-wizard-select.disabled-select .mat-mdc-select-value-text {
  color: #94a3b8 !important;
}
.wg-wizard-number-input {
  height: 42px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0 12px;
  font-size: 14px;
  font-family: inherit;
  color: #0f172a;
  background: white;
  outline: none;
  width: 120px;
  box-sizing: border-box;
}
.wg-wizard-number-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}
:host ::ng-deep .wg-wizard-form .wg-wizard-input input.sem-check-box[type=checkbox] {
  appearance: none;
  -webkit-appearance: none;
  width: 44px !important;
  height: 24px !important;
  background: #cbd5e1;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.2s ease;
  border: none;
  outline: none;
  flex-shrink: 0;
  padding: 0 !important;
  margin: 0;
}
:host ::ng-deep .wg-wizard-form .wg-wizard-input input.sem-check-box[type=checkbox]::after {
  content: "";
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: transform 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
}
:host ::ng-deep .wg-wizard-form .wg-wizard-input input.sem-check-box[type=checkbox]:checked {
  background: #2563eb;
}
:host ::ng-deep .wg-wizard-form .wg-wizard-input input.sem-check-box[type=checkbox]:checked::after {
  transform: translateX(20px);
}
:host ::ng-deep .wg-wizard-form .wg-wizard-input input.sem-check-box[type=checkbox]:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.wg-wizard-menu-intro {
  font-size: 13px;
  color: #64748b;
  margin: 0 0 20px;
}
.wg-sort-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.wg-sort-description {
  font-size: 13px;
  color: #64748b;
  margin: 0;
}
.wg-wizard-add-sort-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: transparent;
  color: #2563eb;
  font-size: 13px;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: color 0.15s ease;
  white-space: nowrap;
}
.wg-wizard-add-sort-link:hover {
  color: #1d4ed8;
}
.wg-wizard-add-sort-link .material-symbols-outlined {
  font-size: 18px;
}
.wg-sort-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  margin-bottom: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.wg-sort-row-number {
  font-size: 13px;
  font-weight: 600;
  color: #94a3b8;
  width: 20px;
  text-align: center;
  flex-shrink: 0;
}
.wg-sort-field-select {
  flex: 1;
  min-width: 0;
}
.wg-sort-order-select {
  width: 160px;
  flex-shrink: 0;
}
.sorting-tab-icon-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #94a3b8;
  transition: all 0.15s ease;
  flex-shrink: 0;
}
.sorting-tab-icon-close:hover {
  background: #fef2f2;
  color: #ef4444;
}
.sorting-tab-icon-close .material-symbols-outlined {
  font-size: 18px;
}
.wg-wizard-error {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 32px 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fef2f2;
  border: 1px solid #fecaca;
}
.wg-wizard-error .material-symbols-outlined {
  font-size: 16px;
  color: #ef4444;
  flex-shrink: 0;
}
.wg-wizard-error p {
  font-size: 12px;
  color: #dc2626;
  margin: 0;
}
.wg-wizard-content-footer {
  padding: 16px 32px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}
.wg-wizard-footer-spacer {
  flex: 1;
}
.wg-wizard-btn-next,
.wg-wizard-btn-save,
.wg-wizard-btn-back,
.wg-wizard-btn-delete {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  border-radius: 10px;
  transition: all 0.15s ease;
}
.wg-wizard-btn-next {
  padding: 10px 20px;
  background:
    linear-gradient(
      135deg,
      #2563eb,
      #1d4ed8);
  color: white;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.3);
}
.wg-wizard-btn-next:hover {
  background:
    linear-gradient(
      135deg,
      #1d4ed8,
      #1e40af);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.35);
}
.wg-wizard-btn-next .material-symbols-outlined {
  font-size: 16px;
}
.wg-wizard-btn-save {
  padding: 10px 20px;
  background:
    linear-gradient(
      135deg,
      #16a34a,
      #15803d);
  color: white;
  box-shadow: 0 2px 6px rgba(22, 163, 74, 0.3);
}
.wg-wizard-btn-save:hover {
  background:
    linear-gradient(
      135deg,
      #15803d,
      #166534);
  box-shadow: 0 4px 12px rgba(22, 163, 74, 0.35);
}
.wg-wizard-btn-save .material-symbols-outlined {
  font-size: 16px;
}
.wg-wizard-btn-back {
  padding: 10px 16px;
  background: transparent;
  color: #64748b;
}
.wg-wizard-btn-back:hover {
  background: #f1f5f9;
  color: #475569;
}
.wg-wizard-btn-back .material-symbols-outlined {
  font-size: 16px;
}
.wg-wizard-btn-delete {
  padding: 10px 16px;
  background: transparent;
  color: #ef4444;
}
.wg-wizard-btn-delete:hover {
  background: #fef2f2;
  color: #dc2626;
}
.wg-wizard-btn-delete .material-symbols-outlined {
  font-size: 16px;
}
.drag-drop-content {
  display: flex !important;
  gap: 0;
  height: 100%;
  min-height: 0;
}
.drag-drop-content .left-container,
.drag-drop-content .right-container {
  flex: 1;
  min-width: 0;
  display: flex !important;
  flex-direction: column !important;
  min-height: 0;
  position: static !important;
  left: auto !important;
  right: auto !important;
  width: auto !important;
  max-width: none !important;
  vertical-align: initial !important;
}
.wg-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.wg-panel-header .wg-wizard-label {
  margin: 0;
  font-size: 11px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  color: #64748b !important;
  float: none !important;
  font-style: normal !important;
  line-height: normal !important;
  position: static !important;
}
.drag-drop-content .left-container .wg-panel-header,
.drag-drop-content .right-container .wg-panel-header {
  float: none !important;
  width: auto !important;
}
.wg-field-count {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
}
.wg-search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  flex-shrink: 0;
}
.wg-search-input-wrapper .material-symbols-outlined {
  position: absolute;
  left: 10px;
  font-size: 18px;
  color: #94a3b8;
  pointer-events: none;
}
.wg-search-input-wrapper input {
  width: 100% !important;
  height: 36px !important;
  border-radius: 8px 8px 0 0 !important;
  border: 1px solid #e2e8f0 !important;
  border-bottom: none !important;
  padding: 0 12px 0 36px !important;
  font-size: 13px !important;
  font-family: inherit;
  color: #0f172a;
  outline: none;
  background: white;
  margin-top: 0 !important;
  box-sizing: border-box;
}
.wg-search-input-wrapper input:focus {
  border-color: #2563eb;
  box-shadow: none;
}
.drag-drop-content .all-search-fields,
.drag-drop-content .added-search-fields {
  flex: 1;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  overflow: hidden !important;
  min-height: 0;
  position: relative !important;
  background: white;
  float: none !important;
  width: auto !important;
  height: auto !important;
  display: flex !important;
  flex-direction: column !important;
  margin-top: 0 !important;
}
.drag-drop-content .left-container .wg-search-input-wrapper + .all-search-fields {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
.drag-drop-content .all-search-fields ul,
.drag-drop-content .added-search-fields ul {
  list-style: none !important;
  margin: 0 !important;
  padding: 0 !important;
  height: 100% !important;
  border: none !important;
  border-radius: 0 !important;
  overflow: hidden !important;
  text-align: left;
}
:host ::ng-deep .drag-drop-content ng-scrollbar {
  height: 100%;
}
.drag-drop-content .all-search-fields li,
.drag-drop-content .added-search-fields li {
  padding: 9px 14px !important;
  font-size: 13px !important;
  color: #334155;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s ease;
  height: auto !important;
  width: auto !important;
  letter-spacing: normal !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0 !important;
  display: block !important;
}
.drag-drop-content .all-search-fields li:hover,
.drag-drop-content .added-search-fields li:hover {
  background: #f8fafc !important;
  width: auto !important;
}
.drag-drop-content .all-search-fields li.active,
.drag-drop-content .added-search-fields li.active {
  background: #eff6ff !important;
  color: #2563eb;
  width: auto !important;
}
.wg-empty-state {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #cbd5e1;
  z-index: 1;
}
.wg-empty-state .material-symbols-outlined {
  font-size: 36px;
  color: #e2e8f0;
}
.wg-empty-state p {
  font-size: 13px;
  color: #94a3b8;
  margin: 0;
}
.drag-drop-content .action-buttons {
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  width: 44px !important;
  height: auto !important;
  flex-shrink: 0;
  position: static !important;
  left: auto !important;
  right: auto !important;
  top: auto !important;
  bottom: auto !important;
  margin: 0 !important;
}
.wg-action-btn {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: all 0.15s ease;
  padding: 0;
}
.wg-action-btn:hover {
  border-color: #2563eb;
  color: #2563eb;
  background: #eff6ff;
}
.wg-action-btn .material-symbols-outlined {
  font-size: 20px;
}
.query-builder-view-settings {
  min-height: 200px;
  flex: 1;
  overflow-y: auto;
}
:host ::ng-deep .query-builder-view-settings .sem-query-builder {
  border: 1px solid #e2e8f0 !important;
  border-radius: 10px !important;
  overflow: hidden;
}
:host ::ng-deep .query-builder-view-settings .q-switch-group,
:host ::ng-deep .query-builder-view-settings .q-button-group {
  padding: 8px 0 !important;
}
:host ::ng-deep .query-builder-view-settings .q-button {
  font-size: 11px !important;
  padding: 4px 10px !important;
  border-radius: 6px !important;
  border: 1px solid #e2e8f0 !important;
  background: white !important;
  color: #334155 !important;
  font-weight: 600 !important;
  cursor: pointer;
  transition: all 0.15s ease;
}
:host ::ng-deep .query-builder-view-settings .q-button:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
}
:host ::ng-deep .query-builder-view-settings .q-switch-label {
  font-size: 10px !important;
  padding: 0 10px !important;
  height: 24px !important;
  line-height: 24px !important;
}
:host ::ng-deep .query-builder-view-settings .q-row {
  display: flex !important;
  align-items: center !important;
  flex-wrap: nowrap !important;
  gap: 6px;
  width: auto !important;
  margin: 6px 12px !important;
  padding: 8px 10px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: #f8fafc;
}
:host ::ng-deep .query-builder-view-settings .q-control-size {
  display: block !important;
  padding-right: 0 !important;
  flex-shrink: 1;
  min-width: 0;
}
:host ::ng-deep .query-builder-view-settings .q-inline-block-display {
  display: block !important;
  flex-shrink: 1;
  min-width: 0;
}
:host ::ng-deep .query-builder-view-settings .q-control-size .mat-mdc-form-field {
  width: 100% !important;
}
:host ::ng-deep .query-builder-view-settings .q-control-size .mat-mdc-text-field-wrapper {
  height: 34px !important;
  padding: 0 8px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  background: white !important;
}
:host ::ng-deep .query-builder-view-settings .q-control-size .mat-mdc-form-field-infix {
  padding: 6px 0 !important;
  min-height: unset !important;
  width: auto !important;
}
:host ::ng-deep .query-builder-view-settings .q-control-size .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .query-builder-view-settings .q-control-size .mdc-line-ripple {
  display: none !important;
}
:host ::ng-deep .query-builder-view-settings .mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {
  opacity: 0 !important;
}
:host ::ng-deep .query-builder-view-settings .q-operator-control,
:host ::ng-deep .query-builder-view-settings .q-field-control,
:host ::ng-deep .query-builder-view-settings .q-entity-control {
  height: 34px !important;
  min-height: 34px !important;
  font-size: 13px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  padding: 0 8px !important;
  background: white !important;
  color: #334155 !important;
  width: 100% !important;
  box-sizing: border-box;
}
:host ::ng-deep .query-builder-view-settings .operator-minwidth {
  min-width: 100px !important;
}
:host ::ng-deep .query-builder-view-settings .q-input-control {
  height: 34px !important;
  min-height: 34px !important;
  font-size: 13px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  padding: 0 10px !important;
  background: white !important;
  color: #334155 !important;
  box-sizing: border-box;
  width: 100% !important;
}
:host ::ng-deep .query-builder-view-settings .q-input-control:focus {
  border-color: #2563eb !important;
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
}
:host ::ng-deep .query-builder-view-settings .input-textfield,
:host ::ng-deep .query-builder-view-settings .input-number,
:host ::ng-deep .query-builder-view-settings .input-datetime {
  min-width: 120px !important;
}
:host ::ng-deep .query-builder-view-settings .remove-rule-icon-container {
  padding-top: 0 !important;
  display: flex !important;
  align-items: center !important;
  margin-left: auto !important;
  float: none !important;
  flex-shrink: 0;
}
:host ::ng-deep .query-builder-view-settings .remove-rule-icon {
  width: 14px !important;
  height: 14px !important;
  cursor: pointer;
  opacity: 0.4;
  transition: opacity 0.15s ease;
}
:host ::ng-deep .query-builder-view-settings .remove-rule-icon:hover {
  opacity: 0.8;
}
:host ::ng-deep .query-builder-view-settings .remove-ruleset-icon {
  left: 0 !important;
  position: relative;
}
:host ::ng-deep .query-builder-view-settings .q-tree {
  margin: 0 !important;
  padding: 0 0 0 12px !important;
}
:host ::ng-deep .query-builder-view-settings .q-ruleset {
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  margin: 6px 12px;
}
:host ::ng-deep .query-builder-view-settings .q-rule {
  border: none !important;
  background: transparent !important;
}
:host ::ng-deep .query-builder-view-settings .q-connector::before,
:host ::ng-deep .query-builder-view-settings .q-connector::after {
  border-color: #cbd5e1 !important;
}
:host ::ng-deep .query-builder-view-settings .sem-drop-down-querybuilder {
  display: inline-block;
  min-width: 120px;
}
:host ::ng-deep .query-builder-view-settings .sem-drop-down-querybuilder .mat-mdc-text-field-wrapper {
  height: 34px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 6px !important;
  background: white !important;
}
:host ::ng-deep .query-builder-view-settings .input-checkbox {
  width: 34px !important;
  height: 34px !important;
}
.sort-view-settings {
  min-height: 100px;
}
:host ::ng-deep .wg-sort-row .mat-mdc-form-field-subscript-wrapper {
  display: none !important;
}
:host ::ng-deep .wg-sort-row .mat-mdc-text-field-wrapper {
  height: 38px !important;
  padding: 0 12px !important;
  border: 1px solid #e2e8f0 !important;
  border-radius: 8px !important;
  background: white !important;
}
:host ::ng-deep .wg-sort-row .mat-mdc-form-field-infix {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
  min-height: unset !important;
}
:host ::ng-deep .wg-sort-row .mdc-line-ripple {
  display: none !important;
}
:host ::ng-deep .wg-sort-row .mat-mdc-form-field:hover .mat-mdc-form-field-focus-overlay {
  opacity: 0 !important;
}
:host ::ng-deep .wg-sort-row .mat-mdc-form-field-focus-overlay {
  display: none !important;
}
:host ::ng-deep .wg-sort-row .mat-mdc-select-trigger {
  height: 100%;
}
:host ::ng-deep .wg-sort-row .mat-mdc-select-value-text {
  font-size: 13px !important;
  color: #334155;
}
:host ::ng-deep .wg-sort-row .mat-mdc-select-arrow-wrapper {
  transform: none !important;
}
/*# sourceMappingURL=sem-view-settings-dialog.component.css.map */
